import React, {Component} from 'react'
import PropTypes from 'prop-types'
import BasketNumber from "./data/BasketNumber"
import classNames from 'classnames'
import humanizeTime from '../../../../helpers/time/humanizeTime'
import BasketQuantity from './data/BasketQuantity'
import ModalBasketDetail from './ModalBasketDetail'


class BasketItem extends Component {
    state = {
        openModal: false
    }

    toggleModalBasketDetail = (e)=>{
        e && e.preventDefault()
        this.setState({
            openModal:
                !this.state.openModal
        })
    }

    componentDidUpdate(prevProps) {
        const { reloadFlag, baskets, basket } = this.props

        // Khi reloadFlag thay đổi → cha reload API
        if (prevProps.reloadFlag !== reloadFlag) {
            // Nếu giỏ này không còn trong mảng baskets → đóng modal
            const exists = baskets.some(b => b._id === basket._id)
            if (!exists && this.state.openModal) {
                this.setState({ openModal: false })
            }
        }
    }

    render() {
        const {openModal} = this.state
        const {basket, reload, reloadFlag} = this.props
        const {_id: basketId, number, items = [], status} = basket

        const itemsCancelledShip = items.filter(item => item.order && item.order.status && item.order.status === 'cancelled' && item.order.sub_status && item.order.sub_status === 'cancel-ship')
        const itemsShiped = items.filter(item => item.order && item.order.production_status && item.order.production_status === 'shipped')
        const itemsCompleted = items.filter(item => item.status && item.status === 'completed')

        const basketClass = itemsCancelledShip.length > 0 || itemsShiped.length > 0 ? 'basket-red' : itemsCompleted.length > 0 ? 'basket-green' : ''

        return (
            <>
                <div className={classNames('BasketItem cursor-pointer', status, basketClass)} onClick={this.toggleModalBasketDetail}>
                    <BasketNumber number={number}/>
                    <BasketQuantity quantity={items.length}/>
                </div>

                {
                    openModal && <ModalBasketDetail visible={openModal} basketNumber={number} basketId={basketId} toggleModalBasketDetail={this.toggleModalBasketDetail} reload={reload} reloadFlag={reloadFlag}/>
                }
            </>
            
        )
    }
}

BasketItem.propTypes = {
    basket: PropTypes.object.isRequired,
}

export default BasketItem
